import { ArrowRight, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16">
      {/* POZADINA SA BRAON/BEŽ NAMEŠTAJEM - VIDLJIVA I USKLAĐENA */}
      <div className="absolute inset-0 z-0">
        {/* Glavna pozadinska slika nameštaja - NEUTRALNA BRAON/BEŽ BOJA */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1540574163026-643ea20ade25?q=80&w=1400&auto=format&fit=crop"
            alt=""
            className="w-full h-full object-cover"
            style={{ filter: 'blur(3px)' }}
            fetchPriority="high"
            decoding="async"
          />
        </div>
        
        {/* Tamni overlay za čitljivost teksta */}
        <div className="absolute inset-0 bg-gradient-to-br from-background/93 via-background/90 to-background/88" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-md mb-6 lg:mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <Star className="w-4 h-4 text-primary fill-primary" />
            <span className="text-sm font-medium text-primary">Premium kvalitet nameštaja</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-foreground leading-[1.1] mb-6 lg:mb-8 animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
            Stil i elegancija
            <span className="block text-primary mt-2 lg:mt-3">za vaš dom</span>
          </h1>

          {/* Subheading */}
          <p className="text-base sm:text-lg lg:text-xl text-primary md:text-white leading-relaxed mb-10 lg:mb-12 max-w-2xl mx-auto animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200">
            Doživite savršenu harmoniju dizajna i funkcionalnosti. Naš nameštaj transformiše prostore u domove pune karaktera i topline.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <Button
              size="lg"
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-base px-10 py-7 shadow-lg hover:shadow-xl transition-all duration-300 group"
              onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Pogledajte ponudu
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              className="bg-white hover:bg-white/90 text-primary font-medium text-base px-10 py-7 shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Saznajte više
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 lg:gap-16 mt-16 lg:mt-20 pt-10 border-t border-white/40 animate-in fade-in duration-700 delay-500 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2">500+</div>
              <div className="text-xs sm:text-sm text-white">Zadovoljnih kupaca</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2">25+</div>
              <div className="text-xs sm:text-sm text-white">Godina iskustva</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2">100%</div>
              <div className="text-xs sm:text-sm text-white">Garancija kvaliteta</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
